import { headers } from '@modules/rest'
import store from '@store'

export const getFileUrl = async (file, employeeId) => {
  const companyId = store.state?.admission?.companyUuid
  const fileId = file?.id || file
  const url = `${import.meta.env.VITE_MIDDLEWARE_URL}/employees/proxy/companies/${companyId}/employees/${employeeId}/document-files/${fileId}/preview/employee`

  return fetch(url, {
    headers: headers([ 'Authorization', 'Accept' ])
  })
    .then(response => response.blob())
    .then(blob => (window.URL || window.webkitURL).createObjectURL(blob))
}

export const getUploadEndpoint = (employeeId, fileId, type) =>
  `${import.meta.env.VITE_MIDDLEWARE_URL}/employees/proxy/companies/${store.state?.admission?.companyUuid}/employees/${employeeId}/document-files/${fileId}/type/${type}/upload/admission`

export const deleteFile = async (variables) => {
  try {
    const companyId = store.state?.admission?.companyUuid
    const { file, employeeId } = variables
    const fileId = file?.id || file
    const url = `${import.meta.env.VITE_MIDDLEWARE_URL}/employees/proxy/companies/${companyId}/employees/${employeeId}/document-files/${fileId}/admission`

    const { data } = await fetch(url, {
      method: 'DELETE',
      headers: headers([ 'Authorization', 'Accept' ])
    })

    return [ false, data ]
  } catch {
    return [ true, null ]
  }
}
